import React from 'react';
import styles from '../toggleSwitch/ToggleSwitch.module.scss';

type Props = {
    checked: boolean;
    onChange: (val: boolean) => void;
    disabled?: boolean
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLInputElement>;

const SimpleToggleSwitch: React.FC<Props> = ({ checked, onChange, disabled, ...props }: Props) => {

    return (

        <label
            className={`${styles.toggleSwitch} ${disabled ? styles.disabled : styles.enabled}`}>
            <input
                {...props}
                type='checkbox'
                checked={checked}
                onChange={e => {
                    if (!disabled) {
                        onChange(e.target.checked);
                    }
                }}
            />
            <span className={styles.switch} />

        </label>

    );


}

export default SimpleToggleSwitch;
